var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRibon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54028 0.948156C1.27894 2.21236 1.27894 4.26203 2.54028 5.52624C3.80163 6.79045 3.80163 8.83846 2.54028 10.1027C1.90959 10.7347 1.08302 11.0587 0.256457 11.0587C0.190802 11.0587 0.125146 11.0807 0.0751173 11.1308C-0.0250391 11.2312 -0.0250391 11.3924 0.0751173 11.4928C0.0960374 11.5138 0.119803 11.5293 0.145017 11.5415C0.159746 11.5476 0.167635 11.5506 0.175623 11.5533C2.49929 12.4648 5.23542 11.9811 7.10799 10.1044C9.63067 7.57596 9.63067 3.47657 7.10799 0.948156C5.84664 -0.316052 3.80163 -0.316052 2.54028 0.948156Z",
    fill: "#00DA93"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibon);
export default __webpack_public_path__ + "static/media/ribon.8dfdbd65696a5d25f34738d8f1dc430e.svg";
export { ForwardRef as ReactComponent };